import CustomDialogYesNoCancel from "./CustomDialogYesNoCancel";

export default CustomDialogYesNoCancel